<template>
  <div v-if="!(HideIfNoTriggers === true && HasTriggers === false)">
    <div class="list" v-if="!OpenedDetailsItem">
      <h1>
        {{Title}}
      </h1>
      <div v-html="Description"></div>
      <table style="width:100%; margin-top:50px;">
        <tr>
          <th class="skill-name-cell">Skill / Employee</th>
          <th v-for="employee in TrackMatrix.employees" :key="employee.id" class="employee-header">
            <img :src="employee.avatar" alt="avatar" class="avatar">
          </th>
          <th>
            <div class="add-div">
              +
            </div>
          </th>
        </tr>
        <tr v-for="skill in TrackMatrix.onboarding.onboardingSteps" :key="skill.id" :class="(HasTriggers && !skill.isCurrent && !DisableScoping) ? 'faded' : ''">
          <td class="skill-name-cell">
            <a @click.stop="openStep(skill)" style="cursor:pointer;">{{ skill.title }}</a>
          </td>
          <td v-for="employee in TrackMatrix.employees" :key="employee.id">
            <div :class="'skill-cell' + (skill.isCurrent ? ' current' : '')" :style="{backgroundColor: getColor(employee.id, skill.id)}" :title="employee.email">
              &nbsp;
            </div>
          </td>
          <td>
          </td>
        </tr>
        <tr>
          <td :colspan="TrackMatrix.employees.length + 2" style="border-bottom:0px solid white !important;">
            <a v-if="HasTriggers && !DisableScoping" @click.stop="DisableScoping = true" style="float:right; cursor:pointer;">Show all</a>
            <a v-if="HasTriggers && DisableScoping" @click.stop="DisableScoping = false" style="float:right; cursor:pointer;">Show current</a>
          </td>
        </tr>
      </table>
    </div>
    <div v-else>
      <h1>
        <a @click.stop="OpenedDetailsItem = null" style="cursor:pointer;"><<</a> {{OpenedDetailsItem.title}}
      </h1>
      <div v-if="OpenedDetailsItem.content && OpenedDetailsItem.content.length > 0" style="margin-top:50px;" v-html="OpenedDetailsItem.content"></div>
      <div v-else style="margin-top:50px; min-height:200px; text-align:center; vertical-align:middle;">
        <span>No information.</span>
      </div>
      <br />
      <div id="workflows">
        <button class="btn btn-danger">
          I have issue
        </button>

        <button class="btn btn-success">
          I am good
        </button>

        <button class="btn btn-success">
          I did this!
        </button>

        <a v-if="OpenedDetailsItem.trigger" :href="OpenedDetailsItem.trigger.launchUrl" target="_blank">
          Open address
        </a>
      </div>
    </div>
  </div>
</template>

<script>

  import TCVelikClient from '@/TCVelikClient/TCVelikClient';

  export default {
    name: "SkillsComponent",
    data() {
      return {
        HasTriggers: false,
        DisableScoping: false,
        matchingSkills: [],
        OpenedDetailsItem: null
      };
    },
    mounted() {
      if (this.$route.query && this.$route.query.triggerurl) {
        var instance = this;

        var allOnobardingSteps = this.TrackMatrix.onboarding.onboardingSteps;
        
        var matches = allOnobardingSteps.filter(function (items) {
          var skill = items;
          var item = items.onboardingStepsCriterias[0];
          if (item && item.operator && item.value) {
            switch (item.operator) {
              case "contains": {
                if (instance.$route.query.triggerurl?.toLowerCase().indexOf(item.value.toLowerCase()) > -1) {
                  skill.isCurrent = true;
                  instance.HasTriggers = true;
                  instance.matchingSkills.push(item);
                  skill.employees = [];
                  return true;
                }
              }
              case "EQUALS": {
                if (instance.$route.query.triggerurl?.toLowerCase() === item.value.toLowerCase()) {
                  skill.isCurrent = true;
                  instance.HasTriggers = true;
                  instance.matchingSkills.push(item);
                  skill.employees = [];
                  return true;
                }
              }
            }
          }
        });

        matches.forEach(itm => function (item) {
          item.isCurrent = true;
        });
      }
    },
    methods: {
      getColor(employeeId, skillId) {
        if (this.TrackMatrix.assessments) {
          const found = this.TrackMatrix.assessments.find(
            a => a.employeeId === employeeId && a.skillId === skillId
          );
          return found ? this.getStatusColor(found.status) : 'silver';
        }
        else {
          return 'silver';
        }
      },
      getStatusColor(status) {
        switch (status) {
          case 'silver': return '#efefef'; // not assessed
          case 'orange': return '#FFA500'; // in progress
          case 'green': return '#38ab63'; // done
          case 'blue': return '#00a1f1'; // mentor
          default: return '#efefef'; // default to not assessed
        }
      },
      openStep(step) {
        var instance = this;

        var req = JSON.stringify({
          query: `query OnboardingStep {
            onboardingStep(where: { id: { eq: ${step.id} } }) {
                id
                title
                onboardingId
                workflowId
                content
            }
        }`
        });

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.OpenedDetailsItem = response.data.data.onboardingStep[0];
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors :(');
          }
        });
      }
    },
    props: ["Title", "Description", "TrackMatrix", "EmployeeId", "HideIfNoTriggers", "TriggerUrl", "Onboardings", "Workflows"]
  }
</script>

<style>

  .btn {
    background: none;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    cursor: pointer;
    margin-left: 5px;
  }

  .btn-danger {
    background-color: indianred;
    border: 1px solid indianred;
    color: white;
  }

  .btn-success {
    background-color: #349539;
    border: 1px solid #349539;
    color: white;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border: 0px solid white;
  }

  th, td {
    border-bottom: 1px solid #ccc;
    padding: 8px;
    text-align: left;
    vertical-align: bottom;
    max-width: 50px !important;
    width: 50px !important;
  }

    th.skill-name-cell, td.skill-name-cell {
      max-width: unset !important;
      width: unset !important;
    }

  th {
    vertical-align: top;
    font-weight: bold;
  }

  .employee-header div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .employee-header span {
    transform: rotate(-90deg);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /*margin-bottom: 40px;*/
    font-weight: 900;
  }

  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-bottom: 5px;
    /*margin-top: 20px;*/
    margin-left: 0px;
    display: block;
    /*border: 5px solid green;*/
    margin-right: 5px;
  }

  h1 {
    font-weight: 900;
    /*margin-top: 2em;*/
  }

  .completed {
    border: 5px solid green;
  }

  .in-progress {
    border: 5px solid orange;
  }

  .not-started {
    border: 5px solid gray;
  }

  .add-div {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    text-align: center;
    border: 1px solid green;
    color: green;
    padding-top: 2px;
    padding-left: 1px;
    cursor: pointer;
    font-size: 2em;
    font-weight: 100;
  }

  .skill-cell {
    border-radius: 50%;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

    .skill-cell.current {
      animation: blink 2s infinite; /* Run the animation indefinitely with a duration of 2 seconds */
    }

  tr.faded {
    /*opacity:0.3;*/
    display: none;
  }

  @keyframes blink {
    0%, 100% {
      opacity: 1; /* Fully visible at the start and end */
    }

    50% {
      opacity: 0; /* Fully invisible in the middle */
    }
  }


  .accordion {
    width: 100%;
  }

  .accordion-item {
    border-bottom: 1px solid #ccc;
  }

  .accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 10px;
  }

  .employee-icons {
    display: flex;
  }

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 5px;
  }

  .add-icon {
    font-size: 24px;
    font-weight: bold;
  }

  .accordion-content {
    display: none;
    padding: 10px;
    background-color: #f9f9f9;
  }

  .status-dot {
    height: 25px;
    width: 25px;
    border-radius: 50%;
    display: inline-block;
  }

  .skill-status {
    display: flex;
    justify-content: space-around;
    padding-top: 10px;
  }
</style>
